// Barre d'accès rapide en bas de l'espace élève, dans les applications Android et iOS :
// cinq boutons (Vidéos, Exercices, Évaluations, Résultats, Assistance), une icône et un petit nom, dans une capsule
// flottante transparente.
import React, { useEffect } from "react";
import { isAndroidApp } from "../platform";
import { Pastille } from "../services/compteurs";

export const BOUTONS_RAPIDES = [
  { vue: "videos", libelle: "Vidéos", icone: "bi-play-circle", iconeActive: "bi-play-circle-fill", compteur: "videos" },
  { vue: "exercices", libelle: "Exercices", icone: "bi-pencil", iconeActive: "bi-pencil-fill", compteur: "exercices" },
  { vue: "evaluations", libelle: "Évaluations", icone: "bi-clipboard-check", iconeActive: "bi-clipboard-check-fill", compteur: "evaluations" },
  { vue: "resultats", libelle: "Résultats", icone: "bi-bar-chart", iconeActive: "bi-bar-chart-fill" },
  { vue: "messages", libelle: "Assistance", icone: "bi-headset", iconeActive: "bi-headset", compteur: "messages" },
];

// Application téléphone : Android (build dédié) ou iOS / Android via Capacitor.
export function estApplicationMobile() {
  const plateforme = typeof window !== "undefined" ? window.Capacitor?.getPlatform?.() : null;
  return isAndroidApp || plateforme === "ios" || plateforme === "android";
}

export default function BarreAccesRapide({ vueActive, onNavigate, compteurs = {}, forcer = false }) {
  const visible = forcer || estApplicationMobile();
  useEffect(() => {
    if (!visible) return undefined;
    document.body.classList.add("ql-avec-barre-rapide");
    // La bulle d'Akili remonte au-dessus de la barre (signal envoyé une fois toute la page montée).
    const signal = window.setTimeout(() => window.dispatchEvent(new Event("resize")), 0);
    return () => {
      window.clearTimeout(signal);
      document.body.classList.remove("ql-avec-barre-rapide");
      window.dispatchEvent(new Event("resize"));
    };
  }, [visible]);
  if (!visible) return null;
  return (
    <nav className="ql-barre-rapide" aria-label="Accès rapide">
      {BOUTONS_RAPIDES.map((b) => {
        const actif = vueActive === b.vue;
        return (
          <button key={b.vue} type="button" className={`ql-barre-rapide-btn${actif ? " actif" : ""}`}
            aria-current={actif ? "page" : undefined} onClick={() => onNavigate(b.vue)}>
            <span className="ql-barre-rapide-icone">
              <i className={`bi ${actif ? b.iconeActive : b.icone}`} aria-hidden="true"></i>
              <Pastille nombre={compteurs[b.compteur]} className="ql-barre-rapide-pastille" />
            </span>
            <span className="ql-barre-rapide-nom">{b.libelle}</span>
          </button>
        );
      })}
    </nav>
  );
}
